"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/navigation";
import { RotateCcw, ServerCrash } from "lucide-react";
import type { Dictionary } from "@/dictionaries/types";
import PageState from "./PageState";

/**
 * "WE COULD NOT LOAD THIS" for a v2 page — LoadError's rule, in the empty
 * frame: a failed server load is never drawn as a 404 (that stays
 * `notFound()`), the HTTP status is shown only when the fetch reported one,
 * and the retry is `router.refresh()`, which re-runs the server render and
 * keeps scroll and client state. LoadError keeps its legacy face for the
 * routes not yet migrated.
 */
export default function LoadFailed(t0) {
  const $ = _c(16);
  const {
    labels,
    detail,
    lang
  } = t0;
  const router = useRouter();
  const isFa = lang === "fa";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ServerCrash aria-hidden={true} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = isFa ? "\u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F" : "Didn't load";
  let t3;
  if ($[1] !== detail || $[2] !== isFa) {
    t3 = detail ? {
      label: isFa ? "\u067E\u0627\u0633\u062E \u0633\u0631\u0648\u0631:" : "Server said:",
      value: detail
    } : undefined;
    $[1] = detail;
    $[2] = isFa;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== router) {
    t4 = () => router.refresh();
    $[4] = router;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <RotateCcw aria-hidden={true} />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== labels.retry || $[8] !== t4) {
    t6 = <button type="button" className="v2-btn v2-focus" onClick={t4}>{t5}{labels.retry}</button>;
    $[7] = labels.retry;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== labels.errorBody || $[11] !== labels.errorTitle || $[12] !== t2 || $[13] !== t3 || $[14] !== t6) {
    t7 = <PageState tone="error" glyph={t1} eyebrow={t2} title={labels.errorTitle} body={labels.errorBody} detail={t3} actions={t6} />;
    $[10] = labels.errorBody;
    $[11] = labels.errorTitle;
    $[12] = t2;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}